import React from 'react';
import type { ColDef, EditableCallbackParams } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getAssetTypes, saveAssetTypesBatch } from '../../api/assetTypes';
import type { AssetType } from '../../types/AssetType';
import { t } from '../../i18n/t';

const assetTypesColumnDefs: ColDef<AssetType>[] = [
  {
    field: 'assetTypeId',
    headerName: t('assetTypes.columns.assetTypeId'),
    width: 140,
    // Natural PK: editable on Add only; existing rows must keep their code.
    editable: (params: EditableCallbackParams<AssetType>) =>
      (params.data as { __status?: string } | undefined)?.__status === 'added',
    cellDataType: 'number',
    sort: 'asc',
  },
  {
    field: 'assetTypeName',
    headerName: t('assetTypes.columns.assetTypeName'),
    flex: 1,
    editable: true,
  },
  {
    // V1.27.0 — type-level multiplier (כופל). FLOAT NULL.
    field: 'multiplier',
    headerName: t('assetTypes.columns.multiplier'),
    width: 110,
    editable: true,
    cellDataType: 'number',
  },
];

const newAssetTypeDefaults = (): Partial<AssetType> => ({
  assetTypeId: 0,
  assetTypeName: '',
  multiplier: null,
});

export function AssetTypesPage() {
  return (
    <LopCrudPage<AssetType>
      resourceCode="assetTypes"
      titleKey="assetTypes.pageTitle"
      idField="assetTypeId"
      getRows={getAssetTypes}
      saveBatch={(added, modified, deletedIds) =>
        saveAssetTypesBatch(added, modified, deletedIds as number[])
      }
      columnDefs={assetTypesColumnDefs}
      newRowDefaults={newAssetTypeDefaults}
    />
  );
}
